import { render, staticRenderFns } from "./DoctorVisitsAdd.vue?vue&type=template&id=0bd1b068&"
import script from "./DoctorVisitsAdd.vue?vue&type=script&lang=js&"
export * from "./DoctorVisitsAdd.vue?vue&type=script&lang=js&"
import style0 from "./DoctorVisitsAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports